<template>
    <DCard
        padding
    >
        <Form
            :available-permissions="availablePermissions"
            :available-tenants="availableTenants"
            :errors="errors"
            :role="role"
            @saveRole="saveRole"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/Roles/Form'

export default {
    name: 'RoleEdit',
    components: { Form },
    props: {
        availablePermissions: {
            type: Array,
            default: () => { return [] }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        role: {
            type: Object,
            default: () => { return {} }
        },
        availableTenants: {
            type: Array,
            default: () => { return [] }
        }
    },
    methods: {
        saveRole (data) {
            this.$inertia.put(this.$route('settings.roles.update', { role: this.role.id }), data)
        }
    }
}
</script>
